// HeicViewerPage.js
import React, { useEffect, useState } from "react";
import heic2any from "heic2any";

const HeicViewerPage = () => {
  const heicUrl = "https://files.prisms.in/sahyadrisemiprisms/2025-2026/Academic/Notifications/pm-Activity/20250624_140223-1750761926189.heic"; // Replace with your actual URL
  const [convertedUrl, setConvertedUrl] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function convertHeicToJpeg() {
      try {
        const response = await fetch(heicUrl);
        if (!response.ok) {
          throw new Error("Image not found or inaccessible.");
        }

        const heicBlob = await response.blob();

        const jpegBlob = await heic2any({
          blob: heicBlob,
          toType: "image/jpeg",
          quality: 0.9,
        });

        const imageUrl = URL.createObjectURL(jpegBlob);
        setConvertedUrl(imageUrl);
      } catch (err) {
        console.error("Conversion error:", err);
        setError("Failed to load or convert the image.");
      }
    }

    convertHeicToJpeg();
  }, [heicUrl]);

  return (
    <div className="page-content" style={{ padding: "20px", fontFamily: "Arial" }}>
      <h2>HEIC Image Viewer</h2>
      {error && <p style={{ color: "red" }}>{error}</p>}
      {!convertedUrl && !error && <p>Loading and converting image...</p>}
      {convertedUrl && (
        <img
          src={convertedUrl}
          alt="Converted from HEIC"
          style={{ maxWidth: "100%", border: "1px solid #ccc" }}
        />
      )}
    </div>
  );
};

export default HeicViewerPage;
